import {LeadCommentModel,LeadModel, SuperBit_swaggerClient,RenewalPrices,LeadFilterModel, PolicyFilterModel,RenewalsSalespersonPolicies, RenewalsFilterModel,RenewalsConfigData, SimulatorOfferModel, RiderPackageModel} from './superbit-api-models';
import generalSettings from '../json/general-settings.json';

export class RenewalsModel {
    client:any;
    constructor() {
        this.init();
    }

    async fetchData () {
        let apiUrl = undefined;
        try {
            const response = await fetch('/config.json');
            const jsonData = await response.json();
            apiUrl = jsonData.apiUrl;
            localStorage.setItem('apiUrl', apiUrl)
            localStorage.setItem('appConfig', JSON.stringify(jsonData));
        } catch (error) {
            console.error('Error fetching data: ', error);
        }
        return apiUrl;
    };


    async init () {
        let apiUrl = localStorage.getItem('apiUrl');
        if (!apiUrl) {
            apiUrl = await this.fetchData();
        }
        var url = apiUrl ? apiUrl : generalSettings.apiUrl;
        //var url = "https://localhost:44333";
        //this.client = new SuperBit_swaggerClient("http://api.dev-alt.superbit.co.il");
        this.client = new SuperBit_swaggerClient(url);//(settings.apiUrl);
    }
    

    async renewalImport () {
        await this.client.renewalImport();
        
    };

    async renewalLinkSalesperson (body:RenewalsSalespersonPolicies) {
        await this.client.renewalLinkSalesperson(body);
        
    };
    
async renewalLinkSalespersonByLetters () {
        await this.client.renewalLinkSalespersonByLetters();
        
    };

    async renewalLinkSalespersonByFilter (filter:RenewalsFilterModel) {
        await this.client.renewalLinkSalespersonByFilter(filter);
        
    };

    async renewalGetSettings () {
        return await this.client.renewalGetSettings();
        
    };
    

    async renewalUpdateSettings(body:RenewalsConfigData|undefined) {
        return await this.client.renewalUpdateSettings(body);
        
    };

    async renewalsGetYears () {
        return await this.client.renewalsGetYears();
        
    };

    async renewalSetManualAllotment (body:any|undefined) {
        return await this.client.renewalSetManualAllotment(body);
        
    };

    async renewalGetAllDetails (renewalId: string | undefined) {
        return await this.client.renewalGetAllDetails(renewalId);
        
    };

    

     async AddLeadsStatus(body:any|undefined) {
        return await this.client.AddLeadsStatus(body);
        
    };

    async DeleteLeadstStatus(body:string|undefined) {
        return await this.client.DeleteLeadstStatus(body);
        
    };
    async GetLeadStatuses(leadSource:number|undefined) {
        return await this.client.GetLeadStatuses(leadSource);
        
    };

    async GetLeadStatuses2(leadSource:number|undefined) {
        return await this.client.GetLeadStatuses2(leadSource);
        
    };

    async renewalSetManualPrices(body:RenewalPrices) {
        return await this.client.renewalSetManualPrices(body);
        
    };
    
async RenewalLeadCommentAdd(body:LeadCommentModel) {
        return await this.client.RenewalLeadCommentAdd(body);
        
    };

    async RenewalLeadCommentAddDelete(id:string|undefined) {
        return await this.client.RenewalLeadCommentAddDelete(id);
        
    };

    async RenewalGetLeadComments(leadId:string) {
        return await this.client.RenewalGetLeadComments(leadId);
        
    };

    async renewalUpsertOffer(offer:SimulatorOfferModel) {
        return await this.client.renewalUpsertOffer(offer);
        
    };

    async getRiders(vehicleId: string): Promise<RiderPackageModel[]> {
        return await this.client.riderGetRidersByConditions2(vehicleId);
    }
    
}